import React from 'react'
import { connect } from 'react-redux'

import { withRouterProps } from '../../utils/with-router-props'
import EditableDisplayField from '../../utils/editable-display-field'
import ManageAuth from '../../utils/manage-auth'

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        account: state.user._computed.accountTypeName,
        role: state.user._computed.roleName
    }
}

const AppUserView = ({ user, account, role }) => {
    const { firstName, lastName, phone } = user
    return (
        <div className="app-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>{firstName} {lastName}'s Profile</h1>
                        <p>{account}<br />{role}</p>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    <div className="content-box editable">
                        <span>
                            Click on any field to edit. Account and Role changes must be made by an administrator.
                        </span>
                        <hr/>
                        <EditableDisplayField
                            label="First Name"
                            display={firstName}
                            endpoint="user"
                            extraClass="flex-33"
                            dataObj={user}
                            inTable={true}
                            fields={[{
                                field: 'firstName',
                                type: 'text',
                                required: true
                            }]} />
                        <EditableDisplayField
                            label="Last Name"
                            display={lastName}
                            endpoint="user"
                            extraClass="flex-33"
                            dataObj={user}
                            inTable={true}
                            fields={[{
                                field: 'lastName',
                                type: 'text',
                                required: true
                            }]} />
                        <EditableDisplayField
                            label="Phone"
                            display={phone}
                            endpoint="user"
                            extraClass="flex-33"
                            dataObj={user}
                            inTable={true}
                            fields={[{
                                field: 'phone',
                                type: 'text',
                                required: true
                            }]} />
                        <hr />
                        <div className="label-values flex-33">
                            <span className="label">Account</span>
                            <p className="values">{account}</p>
                        </div>
                        <div className="label-values flex-33">
                            <span className="label">Role</span>
                            <p className="values">{role}</p>
                        </div>
                        <ManageAuth />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AppUserView))
